import DataTable from 'components/Display/DataTable/DataTable'
import {Page, PageContent} from 'components/Page'
import {
    useDeletePublicationMutation,
    useGetPublicationsQuery,
} from 'store/slices/api/publicationsApi'

const Publications = () => {
    return (
        <Page>
            <PageContent>
                <DataTable
                    allowEdit
                    allowDelete
                    confirmBeforeDelete
                    itemName="publication"
                    paginationType="external"
                    useGetQuery={useGetPublicationsQuery}
                    useDeleteMutation={useDeletePublicationMutation}
                />
            </PageContent>
        </Page>
    )
}

export default Publications
